import API_BASE from "../config.js";
﻿import { authApi } from "../services/api";

function parseJwt(token) {
  try { return JSON.parse(atob(token.split(".")[1])); } catch(e) { return {}; }
}

export const login = async (email, password) => {
  const res = await authApi.post("/auth/login", { email, password });
  const { access_token, refresh_token } = res.data;
  const payload = parseJwt(access_token);
  // Preservar dados do sistema antes de limpar
  const keysToPreserve = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith('os_') || key.startsWith('estoque_') || key.startsWith('clientes_') || key.startsWith('orcamento_'))) {
      keysToPreserve.push({ key, value: localStorage.getItem(key) });
    }
  }
  // sessionStorage garante isolamento por aba - cada tenant em sua propria aba
  sessionStorage.setItem("access_token",  access_token);
  sessionStorage.setItem("refresh_token", refresh_token);
  sessionStorage.setItem("tenant_id",     String(payload.tenant_id || 1));
  sessionStorage.setItem("user_email",    payload.email || "");
  sessionStorage.setItem("user_id",       String(payload.sub || ""));
  sessionStorage.setItem("user_name",     payload.name || "");
  // Manter localStorage apenas para cache de dados
  keysToPreserve.forEach(({ key, value }) => localStorage.setItem(key, value));
  // Buscar plano do tenant
  try {
    const tenantId = payload.tenant_id || 1;
    const tr = await fetch("" + API_BASE + "/api/v1/tenants/" + tenantId, {
      headers: { "Authorization": "Bearer " + access_token },
    });
    const td = await tr.json();
    sessionStorage.setItem("plano",        (td.plan || "basico").toLowerCase());
    localStorage.setItem("tenant_nome",  td.name || "");
    localStorage.setItem("tenant_slug",  td.slug || "");
  } catch {}
  return res.data;
};

export const logout = () => {
  // Limpa so as chaves que este painel (frontend/oficina) realmente usa --
  // nunca localStorage.clear() aqui, pois o Painel Central (admin-panel)
  // roda na mesma origem e guarda seu proprio token no localStorage
  // tambem; um clear() geral derruba a sessao de outra aba/painel.
  try {
    localStorage.removeItem("tenant_nome");
    localStorage.removeItem("tenant_slug");
    localStorage.removeItem("tenant_id");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  } catch {}
  sessionStorage.clear();
  window.location.replace("/login");
};

export const isAuthenticated = () => !!(sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
export const getTenantId = () => parseInt((sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");

